<template>
  <v-row>
    <v-col
      cols="4"
      sm="2"
      md="2"
      v-for="color in colors"
      :key="color"
      class="text-center"
    >
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-badge
            icon="mdi-check"
            :style="
              color === favoriteColor
                ? 'visibility: visible;'
                : 'visibility: hidden;'
            "
            color="blue darken-2"
            overlap
          >
            <v-sheet
              style="visibility: visible !important"
              @click="colorSelected(color)"
              v-on="on"
              v-bind="attrs"
              width="40px"
              height="40px"
              :color="color"
            ></v-sheet>
          </v-badge>
        </template>
        <span>{{ color }}</span>
      </v-tooltip>
    </v-col>
  </v-row>
</template>

<script>
import colors from 'vuetify/lib/util/colors'

export default {
  name: 'ColorTiles',
  props: {
    favoriteColor: {
      type: String,
    },
  },
  data: () => ({
    colors: Object.entries(colors)
      .slice(0, 18)
      .map((o) => o[1].base),
  }),
  methods: {
    colorSelected(color) {
      this.$emit('onColorSelected', color)
    },
  },
}
</script>

<style scoped></style>
